import AddRecurringForm from 'src/components/Forms/AddRecurringForm';
import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';

const AddRecurringModal = () => (
  <ModalBase name={MODALS.addRecurring} size={MODALS_SIZE.large} form={FORM.get_invoice}>
    <AddRecurringForm />
  </ModalBase>
);

export default AddRecurringModal;
